import { render, staticRenderFns } from "./TodasMenssagensChat.vue?vue&type=template&id=288a8b0c&scoped=true"
import script from "./TodasMenssagensChat.vue?vue&type=script&lang=js"
export * from "./TodasMenssagensChat.vue?vue&type=script&lang=js"
import style0 from "./TodasMenssagensChat.vue?vue&type=style&index=0&id=288a8b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288a8b0c",
  null
  
)

export default component.exports